import {
    ACCOUNTS_EXPORT_LOGS_REQUEST,
    ACCOUNTS_EXPORT_LOGS_RESULT,
    ACCOUNTS_EXPORT_SEARCH_USERS_REQUEST,
    ACCOUNTS_EXPORT_SEARCH_USERS_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    result: null,
    nextToken: null,
    users: [],
    loadingUsers: false
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case ACCOUNTS_EXPORT_LOGS_REQUEST:
            return { ...state, loading: true }

        case ACCOUNTS_EXPORT_LOGS_RESULT:
            return {
                ...state,
                loading: false,
                result: action?.payload?.nextToken
                    ? [...state.result, ...action?.payload?.result?.items]
                    : action?.payload?.result?.items,
                nextToken: action?.payload?.result?.nextToken
            }

        case ACCOUNTS_EXPORT_SEARCH_USERS_REQUEST:
            return { ...state, loadingUsers: true }

        case ACCOUNTS_EXPORT_SEARCH_USERS_RESULT:
            return { ...state, loadingUsers: false, users: action.payload }

        case CLEAR_REDUX:
            return ["", "ACCOUNTS_EXPORT_LOGS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};